<div class="header">
  <div class="title">Create Task Role</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="taskRoleForm">
  <mat-form-field>
    <mat-label>Role Name</mat-label>
    <input matInput [formControlName]="'name'" />
    <mat-error>Role Name should have at least 3 characters</mat-error>
  </mat-form-field>

  <!-- Body -->
  <div class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        [disabled]="isSaveBtnDisabled"
        DebounceClick
        (debounceLoading)="isDebounceLoading($event)"
        (debounceClick)="save()"
      >
        <span *ngIf="!isLoading">Create</span>
        <mat-progress-spinner *ngIf="isLoading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
